import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "../../components/Wedding/wedding.css";
import { Hero } from "../../components/Wedding/Hero";
import { Chapters } from "../../components/Wedding/Chapters";
import { OurStory } from "../../components/Wedding/OurStory";
import { WeddingDetails } from "../../components/Wedding/WeddingDetails";
import { Gallery } from "../../components/Wedding/Gallery";
import { MusicPlayer } from "../../components/Wedding/MusicPlayer";
import { Schedule } from "../../components/Wedding/Schedule";
import { Wishes } from "../../components/Wedding/Wishes";
import { GuestCameraPhotos } from "../../components/Wedding/GuestCameraPhotos";
import { Footer } from "../../components/Wedding/Footer";
import {
  type WeddingLanguage,
  weddingContent,
} from "../../components/Wedding/content";

const detectDefaultLanguage = (): WeddingLanguage => {
  return new URLSearchParams(window.location.search).get("lang") === "vi" ? "vi" : "en";
};

export default function Wedding() {
  const [language, setLanguage] = useState<WeddingLanguage>(detectDefaultLanguage);
  const content = weddingContent[language];

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{content.meta.title}</title>
        <meta name="description" content={content.meta.description} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <div
        className="wedding-page"
        style={{ minHeight: "100vh", backgroundColor: "#F5F1EA" }}
      >
        <MusicPlayer />
        <div className="wedding-language-switch-wrap">
          <button
            type="button"
            className="wedding-language-switch"
            aria-label="Toggle wedding page language"
            onClick={() =>
              setLanguage((current) => (current === "en" ? "vi" : "en"))
            }
          >
            <span
              className={`wedding-language-switch__button ${
                language === "en" ? "wedding-language-switch__button--active" : ""
              }`}
            >
              EN
            </span>
            <span
              className={`wedding-language-switch__button ${
                language === "vi" ? "wedding-language-switch__button--active" : ""
              }`}
            >
              VI
            </span>
          </button>
        </div>
        <Hero language={language} />
        <Chapters language={language} />
        <OurStory language={language} />
        <WeddingDetails language={language} />
        <Schedule language={language} />
        <Wishes language={language} />
        <GuestCameraPhotos language={language} />
        <Gallery language={language} />
        <Footer language={language} />
      </div>
    </>
  );
}
